<!--首页-->
<template>
  <div class="home-box cr">
    <!-- <div class="head-box flex ac jc"  :style="{backgroundImage: 'url(' + banner + ')', backgroundRepeat:'no-repeat'}">
      <div class="head-btn1" @click="handleJump('/create')">
        + 创建视频
      </div>
      <div class="head-btn2" @click="handleJump('/profile')">
        定制数字演员
      </div>
    </div> -->

    <div class="newhead-box flex">
      <div
        :style="{
          backgroundImage: 'url(' + banner + ')',
          backgroundRepeat: 'no-repeat',
        }"
        class="newhead-box_mian"
        @click="handleJump('/create')"
      >
        <div class="p_1">AI数字人视频创作</div>
        <div class="p_2">一键上传 快速生成</div>
        <div class="p_3">
          <div class="boreder">立即创作</div>
          <img :src="`编组8.png` | fullImageUrl" />
        </div>
        <img
          class="newhead-box_mian_img1 size-1"
          :src="`编组78.png` | fullImageUrl"
          alt=""
        />
      </div>
      <div
        :style="{
          backgroundImage: 'url(' + banner1 + ')',
          backgroundRepeat: 'no-repeat',
        }"
        class="newhead-box_mian"
        @click="handleJump('/profile')"
      >
        <div class="p_1">数字形象</div>
        <div class="p_2">上传视频 快速复刻数字形象</div>
        <div class="p_3">
          <div class="boreder">快速复制</div>
          <img :src="`编组8.png` | fullImageUrl" />
        </div>
        <img
          class="newhead-box_mian_img1 size-2"
          :src="`编组79.png` | fullImageUrl"
          alt=""
        />
      </div>
      <div
        :style="{
          backgroundImage: 'url(' + banner2 + ')',
          backgroundRepeat: 'no-repeat',
        }"
        class="newhead-box_mian"
        @click="handleJump('/clone')"
      >
        <div class="p_1">声音克隆</div>
        <div class="p_2">上传音频 打造专属个人声音模型</div>
        <div class="p_3">
          <div class="boreder">快速克隆</div>
          <img :src="`编组8.png` | fullImageUrl" />
        </div>
        <img
          class="newhead-box_mian_img1 size-3"
          :src="`编组80.png` | fullImageUrl"
          alt=""
        />
      </div>
    </div>
    <div class="my-works">
      <div class="select-box">
        <div class="flex ac jb">
          <div class="flex ac">
            <div class="pp1" @click="handleChoose(1)">
              我的作品 · {{ newworkList.length }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="flex ac fw">
          <!-- 换成使用图片字段 -->
          <!-- <div
            class="every-video-s"
            v-for="(item, index) in newworkList"
            :key="index"
            :style="{
              backgroundImage: 'url(' + item.cover + ')',
              backgroundRepeat: 'no-repeat',
            }"
            @click="handlePlay2(item)"
          > -->
          <!-- 换成获取视频第一帧 -->
          <div
            class="every-video-s"
            v-for="(item, index) in newworkList"
            :key="index"
            :style="{
              backgroundImage:
                'url(' +
                item.oss_url +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast,ar_auto' +
                ')',
              backgroundRepeat: 'no-repeat',
            }"
            @click="handlePlay2(item)"
          >

            <div class="api-num1" v-if="item.video_channel_name">
              {{ item.video_channel_name }}
            </div>
            <div
              class="api-num1"
              v-if="!item.video_channel_name && getName(item.api_key2)"
            >
              {{ getName(item.api_key2) ? getName(item.api_key2) : "" }}
            </div>
            <!-- <div
              class="api-num1"
              v-if="
                (item.api_name && item.api_key == 'ou') || item.api_key == 'gj'
              "
            >
              {{ item.api_name }}
            </div>
            <div
              class="api-num2"
              v-else-if="item.api_name && item.api_key == 'df'"
            >
              {{ item.api_name }}
            </div>
            <div
              class="api-num3"
              v-else-if="item.api_name && item.api_key == 'fy'"
            >
              {{ item.api_name }}
            </div>
            <div class="api-num-other" v-else>
              {{ item.api_name }}
            </div> -->
            <!-- <img :src="item.cover" alt="cover" @click="handlePlay2(item)" /> -->
            <!-- <p class="pp3 fs15 te">{{ item.name }}</p> -->
            <div class="flex ac jb video-hover">
              <div>
                <!-- <div class="" @click="handlePlay(item)">播放视频</div>
                <div class="" @click="handleJump3(item)">+ 创建视频</div> -->
                <div class="te viode-hover-name">{{ item.name }}</div>
                <div class="te viode-hover-time">{{ item.create_time }}</div>
              </div>
              <div class="video-pop">
                <el-popover
                  ref="popoverRef"
                  placement="top"
                  trigger="hover"
                  v-model="item.visible"
                  width="1"
                >
                  <template>
                    <div class="video-pop-select cr">
                      <div class="select-1" @click.stop="handleReName(item)">
                        重命名
                      </div>
                      <!-- <div class="select-2" @click.stop="handleDown(item)">下载</div> -->
                      <div class="select-2" @click.stop="downVideo(item)">
                        下载
                      </div>

                      <div class="select-3" @click.stop="handleDelete(item)">
                        删除
                      </div>
                    </div>
                  </template>
                  <template slot="reference">
                    <div class="">
                      <img src="../assets/ccc/编组11png.png" />
                    </div>
                  </template>
                </el-popover>
              </div>
            </div>
            <div
              class="shengchenging"
              v-if="item.status != 3 && item.status !== 4"
            >
              <!-- -->

              <div class="desc-pp" v-if="item.api_key == 'ou'">
                <p>排队训练中</p>
                <p>对效果及训练时长不满意</p>
                <p>可以选择更高等级通道训练</p>
              </div>

              <div class="desc-pp" v-else-if="item.api_key == 'gj'">
                <p>免费排队训练中</p>
                <p>时间无法确定预测</p>
                <p>可以选择更高等级通道训练</p>
              </div>
              <div class="desc-pp" v-else-if="item.api_key == 'df'">
                <p>极速训练中3~5分钟</p>
                <p>如对生成效果不满意</p>
                <p>可选择更高等级训练</p>
              </div>
              <div class="desc-pp" v-else-if="item.api_key == 'fy'">
                <p>深度训练中</p>
                <p>6~10分钟请耐心等待</p>
              </div>
              <div class="desc-pp" v-else>
                <p>正在为您训练中</p>
                <p>请耐心等待</p>
              </div>

              <!-- <img
                src="https://xcyq.oss-cn-qingdao.aliyuncs.com/weChatApp/loadingGif2.gif"
                alt="gif"
              /> -->
              <img :src="`uploadingGif.gif` | fullImageUrl" alt="gif" />
            </div>
            <div class="shengchenging" v-if="item.status == 4">
              <div class="desc-pp">
                <p>生成失败，重新生成</p>
                <p>或选择更高等级训练</p>
              </div>
            </div>
          </div>
          <div v-if="newworkList.length <= 0" class="no-info-box tc">
            <img :src="`编组27.png` | fullImageUrl" alt="i" />
            <p>
              暂无内容，<span
                style="color: #f7d274"
                @click="handleJump('/create')"
                >点我立即创建视频</span
              >
            </p>
          </div>
        </div>

        <!-- <div class="flex ac fw" v-if="hsState == 1">
          <div
            class="every-video-h"
            @mouseover="handleMouse(item)"
            @mouseleave="handleMouseOut"
            v-for="(item, index) in workList"
            :key="index"
          >
            <img :src="item.cover_small" alt="cover" />
            <p class="pp3 fs15 te">{{ item.name }}</p>
            <div v-if="hoverId == item.id">
              <div class="head-btn1 btn1-top" @click="handlePlay(item)">
                播放视频
              </div>
              <div class="head-btn1 btn2-top" @click="handleJump3(item)">
                + 创建视频
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="voice-ku" v-if="titleState == 2">
        <div class="flex ac fw">
          <div
            class="every-voice flex ac"
            v-for="(item, index) in voiceArray"
            :key="index"
            :style="{
              backgroundColor: theme.homeColor10,
              borderColor: theme.homeColor7,
            }"
          >
            <div
              class="card-img"
              @mouseover="handleMouse2(item)"
              @mouseleave="handleMouseOut2"
              @click="handlePlay2(item)"
            >
              <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="" />
              <div
                class="hover-box icon-player playing"
                v-if="mouseState && hoverId == item.id"
              >
                <div class="play-pause-btn">
                  <i
                    class="el-icon-video-play"
                    v-if="palyState == 1 || clickId != item.id"
                    style="color: #ffffff; font-size: 25px"
                  ></i>
                  <i
                    class="el-icon-video-pause"
                    v-if="palyState == 2"
                    style="color: #ffffff; font-size: 25px"
                  ></i>
                  <img
                    class="playing-box"
                    v-if="palyState == 3 && clickId == item.id"
                    src="../assets/pcImages/voice-playing.gif"
                  />
                </div>
              </div>
            </div>
            <div>
              <p class="pp4 te" :style="{ color: theme.homeColor8 }">
                {{ item.name }}
              </p>
              <p class="pp5" :style="{ color: theme.homeColor9 }">
                {{ site_title }}高保真音频
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="beian-box fs11 flex ac jc" :style="{ color: theme.layout7 }">
        <div class="mr05" v-if="icp" @click="goBeian">
          <span>{{ icp }}</span>
        </div>
        <div class="mr05 flex ac" v-if="gabeian">
          <img src="../assets/images/gonganbeihao.png" alt="" />
          <div v-html="gabeian"></div>
        </div>
        <div class="mr05" v-if="copyright">
          <div v-html="copyright"></div>
        </div>
        <div class="" v-if="diy_label">
          <div v-html="diy_label"></div>
        </div>
      </div> -->
    </div>
    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video
          ref="videoPlayer"
          style="width: 100%; height: 100%"
          controls=""
          autoplay=""
          :src="videoUrl"
        ></video>
      </div>
    </el-dialog>
    <el-dialog
      title="重命名"
      :visible.sync="dialogVisible3"
      width="25%"
      top="35vh"
    >
      <el-input v-model="name" placeholder="请输入名字" style="width: 100%" />
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sumbitName">确 定</el-button>
      </span>
    </el-dialog>
    <audio
      style="
        width: 1px;
        height: 1px;
        opacity: 0;
        position: fixed;
        right: 0;
        bottom: 0;
      "
      ref="audioPlayer"
      @ended="audioEnded"
      :src="audioSrc"
      controls
    ></audio>

    <el-dialog
      title="视频下载进度"
      :visible.sync="dialogVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="25%"
      top="35vh"
    >
      <div>
        <el-progress :percentage="progress"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  delWorks,
  getIndexVideo,
  getVoice,
  site,
  getWorks,
  postWorks,
  gVideoChannel,
} from "../api/user";

export default {
  name: "",
  data() {
    return {
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "2",
          label: "生成中",
        },
        {
          value: "3",
          label: "生成成功",
        },
        {
          value: "4",
          label: "生成失败",
        },
      ],
      value: "",
      input2: "",
      autoState: false,
      workList: [],
      selectObj: {
        source: "2",
        page: 1,
        limit: 9999,
        name: "",
      },
      hoverId: "",
      dialogVisible: false,
      videoName: "",
      videoUrl: "",
      titleState: 1,
      hsState: 2,
      voiceArray: [],
      mouseState: false,
      palyState: 1,
      audioSrc: "",
      clickId: false,
      site_title: "",
      banner: "",
      banner1: "",
      banner2: "",
      icp: "",
      gabeian: "",
      copyright: "",
      cert: "",
      safety_cert: "",
      diy_label: "",
      popoverVisible: null,
      newselectObj: {
        page: 1,
        limit: 9999,
        name: "",
      },
      newworkList: [],
      dialogVisible3: null,
      myOneVoice: {},
      name: "",
      mouseState: false,
      audioSrc: "",
      dialogVisible4: false,
      videoChannelList: [],
    };
  },
  computed: {
    theme() {
      return this.$store.getters.getTheme;
    },
  },
  created() {
    // this.getWorksList();
    // this.getVoiceList();
    // this.getSite();
    this.getWorksListnew();
    this.banner = this.$options.filters.fullImageUrl(`编组77.png`);
    this.banner1 = this.$options.filters.fullImageUrl(`编组77.png`);
    this.banner2 = this.$options.filters.fullImageUrl(`编组77.png`);
    this.getgVideoChannel();
  },
  methods: {
    // 获取通道的名字
    getName(api) {
      console.log("222000000", api);
      if (this.videoChannelList.length > 0) {
        for (let i = 0; i < this.videoChannelList.length; i++) {
          if (this.videoChannelList[i].api == api) {
            return this.videoChannelList[i].name;
            break;
          }
        }
      }
    },
    getgVideoChannel() {
      gVideoChannel().then((res) => {
        this.videoChannelList = res.data.list;
      });
    },
    downvideoUrl(item) {
      console.log("222", item);
    },
    handleDelete(item) {
      this.$confirm("此操作将永久删除该作品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delWorks({ id: item.id }).then(() => {
            this.getWorksListnew();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleDown(item) {
      const url = item.url;
      const filename = item.name + ".mp3";
      const element = document.createElement("a");
      element.href = url;
      element.download = filename;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    handleReName(item) {
      this.dialogVisible3 = true;
      this.myOneVoice = item;
    },
    sumbitName() {
      if (this.myOneVoice.id) {
        if (!this.name) {
          this.$message.error("请填写名称后保存");
        } else {
          postWorks({ id: this.myOneVoice.id, name: this.name })
            .then((res) => {
              this.dialogVisible3 = false;
              this.name = "";
              this.myOneVoice = {};
              this.getWorksListnew();
            })
            .catch((error) => {
              this.$message.error(error.msg);
            });
        }
      }
    },
    getWorksListnew() {
      getWorks({ ...this.newselectObj }).then((res) => {
        console.log("video=======", res);
        this.newworkList = res.data.list;
      });
    },
    hideaaaaa(e) {
      console.log("我隐藏了", e);
    },
    showaaaaa(e) {
      console.log("我显示了", e);
    },
    goBeian() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
    // 获取配置
    getSite() {
      // console.log('theme',this.theme)
      this.banner = this.$options.filters.fullImageUrl(`编组7.png`);
      console.log("获取配置222", this.banner);

      site().then((res) => {
        this.site_title = res.data.site_title
          ? res.data.site_title
          : "AI引爆获客";

        const regex = new RegExp("<img", "gi");
        this.icp = res.data.icp;
        this.gabeian = res.data.gabeian;
        this.copyright = res.data.copyright;
        this.diy_label = res.data.diy_label
          ? res.data.diy_label.replace(regex, `<img style="max-height: 20px"`)
          : "";
      });
    },
    handleChoose(val) {
      this.titleState = val;
    },
    handleHs(val) {
      this.hsState = val;
      this.getWorksList();
    },
    handleMouse(item) {
      this.hoverId = item.id;
    },
    select() {
      this.getWorksList();
    },
    handleMouseOut() {
      this.hoverId = "";
      this.popoverVisible = false;
    },
    handleJump(val) {
      this.$router.push(val);
    },
    handleJump2() {
      this.$router.push({
        path: "/clone",
        query: {
          id: 2,
        },
      });
    },
    handleJump3(item) {
      this.$router.push({
        path: "/create",
        query: {
          id: item.id,
          hs: this.hsState,
        },
      });
    },
    getWorksList() {
      getIndexVideo({ ...this.selectObj }).then((res) => {
        // this.workList = res.data.list
        console.log("video=======", res);
        console.log("video=======", this.hsState);

        if (this.hsState == 1) {
          this.workList = res.data.hlist;
        } else {
          this.workList = res.data.slist;
        }
      });
    },
    getVoiceList() {
      getVoice({ source: "2", page: 1, limit: 9999 }).then((res) => {
        this.voiceArray = res.data.list;
      });
    },
    handlePlay(item) {
      this.videoName = item.name;
      this.videoUrl = item.url;
      this.dialogVisible = true;
    },
    handleDialogClose() {
      // 停止视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },

    handleMouse2(item) {
      this.mouseState = true;
      this.hoverId = item.id;
    },
    handleMouseOut2() {
      if (this.palyState != 3) {
        this.mouseState = false;
      }
    },
    handlePlay2(item) {
      this.videoName = item.name;
      this.videoUrl = item.url;
      console.log("222", this.videoUrl);

      this.videoId = item.id;
      this.dialogVisible = true;
      // this.audioSrc = item.url;

      // this.$nextTick(() => {
      //   const audio = this.$refs.audioPlayer;
      //   console.log("我点击了", audio);

      //   audio.load();
      //   audio.play();
      // });
      // this.mouseState = true;
      // this.clickId = item.id;
      // if (this.palyState == 1) {
      //   this.palyState = 3;
      //   this.audioSrc = item.url;
      //   this.$nextTick(() => {
      //     const audio = this.$refs.audioPlayer;
      //     audio.load();
      //     audio.play();
      //   });
      // } else if (this.palyState == 3) {
      //   this.palyState = 1;
      //   this.$refs.audioPlayer.pause();
      // }
    },
    audioEnded() {
      this.palyState = 1;
    },

    downVideo(item) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", item.url, true);
      // xhr.open('GET', require('../../assets/images/test.mp4'), true)
      xhr.responseType = "blob"; // 返回类型blob
      // 监听进度
      xhr.onprogress = function (e) {
        if (e.lengthComputable) {
          // 文件总体积
          console.log(e.total);
          // 已下载体积
          console.log(e.loaded);
        }
      };
      xhr.onload = function () {
        this.show = false;
        if (xhr.readyState === 4 && xhr.status === 200) {
          const blob = this.response;
          // 转换一个blob链接
          const u = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          // a.download = '1344.mp4'
          var str = "";
          str = new Date().getTime() + ".mp4";
          a.download = str;
          a.href = u;
          // a.style.display = 'none'
          document.body.appendChild(a);
          a.click();
          // a.remove();
          // 释放
          console.log("结束");
          window.URL.revokeObjectURL(u);
        } else {
          console.log("失败了");
        }
      };
      xhr.onerror = function () {
        console.log("下载失败");
      };
      xhr.send();
    },
  },
  /**加载完组件时执行(加载完成之后执行)*/
  mounted() {},
};
</script>

<style scoped lang="scss">
.no-info-box {
  margin: 100px auto;
  color: #ffffffaa;
  img {
    width: 134px;
    height: 104px;
  }
  p {
    font-weight: 400;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
  }
}
.video-pop-select {
  height: 128px;
  // background: #121212;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.88);
  .select-1 {
  }
  .select-2 {
  }
  .select-3 {
  }
}

.newhead-box {
  align-content: center;
  justify-content: space-between;
  .newhead-box_mian {
    // width: 398px;
    width: 100%;
    // height: 240px;
    /*background: url("../assets/pcImages/1.1_Banner@2x.png") no-repeat;*/
    background-size: 100% 100%;
    height: 142px;
    padding: 21px 24px;
    margin-right: 50px;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: center;
    position: relative;
    .newhead-box_mian_img1 {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .size-1 {
      width: 148px;
      height: 106px;
    }
    .size-2 {
      width: 150px;
      height: 116px;
    }
    .size-3 {
      width: 120px;
      height: 116px;
    }
    .p_1 {
      font-weight: 500;
      font-size: 20px;
      color: #f7d274;
    }
    .p_2 {
      margin-top: 5px;
      font-weight: 400;
      font-size: 15px;
      color: rgba(229, 230, 238, 0.9);
    }
    .p_3 {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(247, 210, 116, 0.2);
      background: #1c1c1f;
      border-radius: 10px;
      width: 106px;
      height: 32px;
      .boreder {
        font-weight: 500;
        font-size: 14px;
        color: #bcae8b;
        line-height: 10px;
      }
      img {
        // margin-bottom: 3px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
p {
  margin: 0;
  padding: 0;
}

.home-box {
  font-size: 18px;
  cursor: pointer;
  padding: 28px 40px 0 40px;

  .head-box {
    width: 1640px;
    height: 240px;
    /*background: url("../assets/pcImages/1.1_Banner@2x.png") no-repeat;*/
    background-size: 100% 100%;
    padding-top: 142px;

    .head-btn1 {
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      width: 144px;
      height: 44px;
      background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
      border-radius: 8px;
      margin-right: 16px;
    }

    .head-btn2 {
      font-weight: 600;
      font-size: 16px;
      color: #08ecf6;
      line-height: 44px;
      text-align: center;
      width: 144px;
      height: 44px;
      border-radius: 8px !important;
      border: 1px solid;
    }
  }

  .my-works::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .my-works {
    box-sizing: border-box;
    /*padding: 0 24px 24px 24px;*/
    /*background: #ffffff;*/
    border-radius: 10px;
    height: calc(100vh - 80px - 190px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE 10+ */

    .select-box {
      padding: 15px 0;
      height: 80px;
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 999;
      /*background: #0D1027;*/
      background: #131317;
      .pp1 {
        font-weight: 500;
        line-height: 60px;
        font-size: 16px;
        color: #eeeeee;
        margin-right: 16px;
      }

      .pp1-active {
        color: #01fbf5 !important;
      }

      .hs-box {
        width: 90px;
        height: 28px;
        background: #0e1126;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.15);

        .normal {
          width: 44px;
          height: 24px;
          border-radius: 4px;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #fafafaaa;
          line-height: 24px;
        }

        .hs-active {
          background: #6c14ff;
          border-radius: 4px;
          color: #ffffff;
        }
      }
    }

    .every-video-s {
      position: relative;
      margin: 0 50px 36px 0;
      width: 182px;
      height: 324px;
      border-radius: 16px;
      background-size: contain;
      background-position: center;
      border: 1px solid rgba(255, 255, 255, 0.15);
      .api-num1,
      .api-num2,
      .api-num3,
      .api-num-other {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 9;
        min-width: 57px;
        height: 20px;
        background: #959494;
        border-radius: 4px;
        /*opacity: 0.3;*/
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        padding: 0 6px;
        // white-space: nowrap;
      }
      .api-num2 {
        background: #eaddad;
        opacity: 0.9;
        color: #604e10;
      }

      .api-num3 {
        background: #3afaf5;
        opacity: 0.9;
        color: #26415a;
      }

      .api-num-other {
        background: #6c14ff;
        opacity: 0.9;
        color: #e3d8f7;
      }
      // img {
      //   width: 243px;
      //   height: 432px;
      //   border-radius: 16px;
      //   object-fit: fill;
      // }
      .video-hover {
        position: absolute;
        width: 100%;
        height: 48px;
        background: #1c1c1f;
        // border: 1px solid rgba(255, 255, 255, 0.15);
        // border-top-width: 0;
        border-radius: 0px 0px 14px 14px;
        // left: 25px;
        // bottom: 30px;
        bottom: 0;
        padding: 6px 12px;

        .viode-hover-name {
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
        .viode-hover-time {
          padding-top: 5px;
          font-weight: 400;
          font-size: 10px;
          color: rgba(255, 255, 255, 0.6);
        }
        .video-pop {
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
      .shengchenging {
        z-index: 9;
        position: absolute;
        width: 100%;
        height: calc(100% - 64px);
        border-radius: 16px 16px 0 0;
        top: 0;
        left: 0;
        background: rgba(42, 41, 41, 0.7);
        /*background: url('../assets/images/shengchengBg.jpg') no-repeat;*/
        /*background-size: 100% 100%;*/
        text-align: center;
        font-size: 14px;

        .desc-pp {
          padding-top: 200px;
        }

        img {
          /*padding-top: 280px;*/
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          /*height: 40px;*/
        }

        .pt150 {
          padding-top: 120px;
        }
      }
      .head-btn1 {
        position: absolute;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        width: 96px;
        height: 28px;
        background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
        border-radius: 4px;
        margin-right: 16px;
      }

      .btn1-top {
        left: 25px;
        bottom: 55px;
      }

      .btn2-top {
        left: 130px;
        bottom: 55px;
      }

      .pp3 {
        width: 243px;
        text-align: center;
        margin-top: 16px;
      }
    }

    // .every-video-s:nth-child(6n) {
    //   margin: 0 0 36px 0 !important;
    // }

    .every-video-h {
      position: relative;
      margin: 0 22px 36px 0;

      img {
        width: 308px;
        height: 174px;
        background: #2c2c2c;
        border-radius: 16px;
        object-fit: contain;
      }

      .head-btn1 {
        position: absolute;
        left: 80px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        width: 96px;
        height: 28px;
        background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
        border-radius: 8px;
        margin-right: 16px;
      }

      .btn1-top {
        left: 55px;
        bottom: 55px;
      }

      .btn2-top {
        left: 170px;
        bottom: 55px;
      }

      .pp3 {
        width: 243px;
        text-align: center;
        margin-top: 16px;
      }
    }

    .every-video-h:nth-child(5n) {
      margin: 0 0 36px 0 !important;
    }
  }
}

.dialog-video {
  width: 100%;
  height: 440px;
}

.voice-ku {
  .pp1 {
    font-size: 16px;
    line-height: 1;
    color: #091221;
    font-weight: 500;
    margin-bottom: 24px;

    span {
      font-size: 12px;
      margin-left: 8px;
      color: #888;
      letter-spacing: 1px;
    }
  }

  .every-voice {
    margin: 0 20px 24px 0;
    padding: 16px 18px;

    width: 392px;
    height: 80px;
    /*background: #24273C;*/
    border-radius: 8px;
    border: 1px solid;

    .card-img {
      position: relative;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 50%;
      }

      .hover-box {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        cursor: pointer;
        justify-content: center;
        align-items: center;

        .play-pause-btn {
          margin-top: 10px;

          .playing-box {
            width: 30px;
            height: 18px;
          }
        }
      }
    }

    .pp4 {
      width: 295px;
      font-weight: 400;
      font-size: 16px;
      color: #fafafa;
      text-align: left;
      margin-bottom: 4px;
    }

    .pp5 {
      font-weight: 400;
      font-size: 12px;
      color: #fafafaaa;
      text-align: left;
    }

    .all-tags {
      .every-tag {
        font-size: 12px;
        color: #5b647a;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
        font-weight: 400;
        background: #edeef7;
        border-radius: 4px;
        padding: 0 4px;
        white-space: nowrap;
        margin-right: 5px;
      }
    }
  }

  .every-voice:nth-child(4n) {
    margin: 0 0 24px 0 !important;
  }
}
.beian-box {
  font-size: 12px;
  position: fixed;
  bottom: 5px;
  text-align: center;
  width: 100%;
  height: 20px;
  img {
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
}
</style>
<style>
/* .home-box .el-input {
  width: 200px !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/home.vue